'use client';
import { FC, useEffect, useState } from 'react';
import { CmsProduct, GetProductAction } from '../types/cmsProduct';
import {
  ComponentProductMetadata,
  VerticalType,
} from '../types/cmsTypes';
import { PushDataLayerFn } from '../types/pushDataLayer';
import Spinner from './icons/Spinner';
import ProductContent from './ProductPage/ProductContent';

interface ProductAsideModalProps {
  vertical: VerticalType;
  url_alias: string;
  id_scroll_to: string | null;
  isPreview?: boolean;
  getProductAction: GetProductAction;
  tableConfig: ComponentProductMetadata | undefined;
  pushDataLayer: PushDataLayerFn;
}

export const ProductAsideModal: FC<ProductAsideModalProps> = (props) => {
  const {
    vertical,
    url_alias,
    id_scroll_to,
    isPreview,
    getProductAction,
    tableConfig,
    pushDataLayer,
  } = props;
  const [product, setProduct] = useState<CmsProduct | null>(null);

  useEffect(() => {
    setProduct(null);
    (async () => {
      const productData = await getProductAction(url_alias, !!isPreview);
      if (productData) {
        setProduct(productData);
      }
    })();
  }, [url_alias, vertical, isPreview, getProductAction]);

  useEffect(() => {
    let timeout: number;
    if (product && id_scroll_to) {
      timeout = setTimeout(() => {
        document.getElementById(id_scroll_to)?.scrollIntoView({
          behavior: 'smooth',
        });
      }, 250) as unknown as number;
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [product, id_scroll_to]);

  if (!product) {
    return (
      <div
        // eslint-disable-next-line tailwindcss/no-arbitrary-value
        className="flex min-h-[90vh] w-full items-center justify-center"
      >
        <Spinner className="size-14 animate-spin md:size-20 lg:size-28" />
      </div>
    );
  }

  const productBlock = tableConfig?.product_card?.find(
    (pc) => pc.productBlock?.product?.uid === product.uid,
  )?.productBlock;

  return (
    <ProductContent
      slug={url_alias}
      vertical={vertical}
      product={product}
      ctaLinkOverride={productBlock?.override_cta_link}
      pushDataLayer={pushDataLayer}
    />
  );
};
